/*
 * DRIVLY-UI React Components
 * @license MIT
 */
const t=t=>/^0[^.\s]+$/.test(t);export{t as isZeroValueString};
//# sourceMappingURL=is-zero-value-string.js.map
